import { ReactElement } from 'react';

import withIcon from '../withIcon';

const Terminal = (): ReactElement => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 512.000000 512.000000"
    >
      <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)">
        <path
          d="M116 4500 c-37 -12 -85 -56 -102 -97 -11 -26 -14 -120 -14 -463 l0
-430 2560 0 2560 0 0 429 c0 279 -4 440 -11 458 -15 42 -68 92 -109 103 -44
12 -4842 12 -4884 0z m3174 -280 c49 -13 109 -66 131 -114 24 -53 24 -139 0
-191 -75 -165 -313 -167 -395 -3 -42 85 -31 170 32 240 62 69 143 93 232 68z
m656 -26 c70 -43 108 -117 101 -200 -9 -114 -87 -194 -197 -202 -72 -5 -122
11 -171 55 -77 70 -92 200 -33 286 67 96 199 124 300 61z m580 17 c56 -25 110
-92 124 -152 33 -136 -73 -269 -214 -269 -102 1 -195 75 -215 171 -38 177 141
324 305 250z"
        />
        <path
          d="M0 1966 c0 -832 3 -1224 11 -1243 15 -42 68 -92 109 -103 48 -14
4832 -14 4880 0 41 11 94 61 109 103 8 19 11 411 11 1243 l0 1214 -2560 0
-2560 0 0 -1214z m1777 540 c11 -6 153 -123 313 -260 219 -186 296 -257 307
-284 19 -46 12 -125 -14 -160 -38 -52 -587 -511 -630 -528 -77 -30 -160 6
-201 86 -25 49 -24 97 3 150 8 15 109 107 224 206 l210 178 -32 27 c-212 176
-385 331 -401 358 -39 68 -19 166 45 213 49 37 122 43 176 14z m1720 -928
c122 -67 116 -241 -11 -299 -37 -17 -72 -19 -396 -19 -349 0 -357 0 -400 23
-51 26 -78 59 -90 110 -20 90 33 175 123 198 17 4 192 7 387 6 316 -2 359 -4
387 -19z"
        />
      </g>
    </svg>
  );
};

export default withIcon(Terminal);
